<template>
    <div class="page-container">
        <!-- 用户信息区域 -->
        <div class="user-section">
            <div class="user-info">
                <div class="avatar">
                    <img src="https://img.icons8.com/fluency/96/user-male-circle.png" mode="aspectFit"/>
                </div>
                <div class="user-detail">
                    <span class="user-name">{{ userInfo.name || '匿名' }}</span>
                    <span class="user-phone">手机: {{ formattedPhone }}</span>
                </div>
            </div>
            <div class="bind-btn" v-if="!isBound" @click="showBindModal = true">
                <span>立即绑定</span>
            </div>
        </div>

        <!-- 费用汇总区域 -->
        <div class="fee-section">
            <div class="fee-item balance">
                <span class="fee-label">余额（人民币）</span>
                <span class="fee-value" :class="{ negative: (feeSummary.balance || 0) < 0 }">
                    {{ (feeSummary.balance || 0) < 0 ? '-' : '' }}{{ Math.abs(feeSummary.balance || 0) }}
                </span>
            </div>
            <div class="fee-row">
                <div class="fee-item">
                    <span class="fee-label">总费用（人民币）</span>
                    <span class="fee-value">{{ feeSummary.orderAmount_total || '0.00' }}</span>
                </div>
                <div class="fee-item">
                    <span class="fee-label">已支付（人民币）</span>
                    <span class="fee-value">{{ feeSummary.receivedAmount_total || '0.00' }}</span>
                </div>
            </div>
            <div class="order-badge" @click="goToOrder()">
                未完成订单 {{ orderCount }}
            </div>
        </div>

        <!-- 我的订单 -->
        <div class="order-section">
            <div class="section-header">
                <span class="section-title">我的订单</span>
                <span class="section-more" @click="goToOrder('processing')">进行中: {{ processingCount }} ></span>
            </div>
            <div class="order-tabs">
                <div class="order-tab" @click="goToOrder('pending')">
                    <div class="tab-icon icon-pending">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ff9500" stroke-width="2">
                            <line x1="12" y1="5" x2="12" y2="19"></line>
                            <line x1="5" y1="12" x2="19" y2="12"></line>
                        </svg>
                    </div>
                    <span class="tab-text">待接单</span>
                </div>
                <div class="order-tab" @click="goToOrder('processing')">
                    <div class="tab-icon icon-processing">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1e88e5" stroke-width="2">
                            <circle cx="12" cy="12" r="10"></circle>
                            <polyline points="12 6 12 12 16 14"></polyline>
                        </svg>
                    </div>
                    <span class="tab-text">进行中</span>
                </div>
                <div class="order-tab" @click="goToOrder('completed')">
                    <div class="tab-icon icon-completed">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#4caf50" stroke-width="2">
                            <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                    </div>
                    <span class="tab-text">已完成</span>
                </div>
            </div>
            <div class="view-all-order" @click="goToOrder">
                查看全部订单
            </div>
        </div>

        <!-- 功能列表 -->
        <div class="menu-section">
            <div class="menu-item" @click="goToContacts">
                <span class="menu-icon">
                    <img src="https://img.icons8.com/color/48/contacts.png" mode="aspectFit"/>
                </span>
                <span class="menu-text">我的通讯录</span>
                <span class="menu-arrow">></span>
            </div>
            <div class="menu-item" @click="goToPrivacy">
                <span class="menu-icon">
                    <img src="https://img.icons8.com/color/48/privacy.png" mode="aspectFit"/>
                </span>
                <span class="menu-text">用户隐私服务政策</span>
                <span class="menu-arrow">></span>
            </div>
        </div>

        <!-- 绑定手机号弹窗 -->
        <van-popup v-model="showBindModal" position="bottom">
            <div class="bind-modal">
                <div class="modal-header">
                    <span class="modal-title">绑定手机号</span>
                    <span class="modal-close" @click="showBindModal = false">×</span>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <span class="form-label">手机号</span>
                        <input class="form-input" type="tel" placeholder="请输入手机号" v-model="bindForm.phone"/>
                    </div>
                    <div class="form-group">
                        <span class="form-label">验证码</span>
                        <div class="code-input-group">
                            <input class="form-input code-input" type="text" placeholder="请输入验证码" v-model="bindForm.code"/>
                            <button class="code-btn" :disabled="countdown > 0" @click="sendCode">
                                {{ countdown > 0 ? countdown + 's' : '获取验证码' }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <van-button type="primary" class="submit-btn" @click="handleBind">确认绑定</van-button>
                </div>
            </div>
        </van-popup>

        <div class="tab-bar-bottom">
            <div class="tab-bar-bottom-item" @click="handleTabClick('home')">
                <span class="tab-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                    </svg>
                </span>
                <span class="tab-text">首页</span>
            </div>
            <div class="tab-bar-bottom-item active1">
                <span class="tab-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                        <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                </span>
                <span class="tab-text">我的</span>
            </div>
        </div>
        <div style="height: 100px;"></div>
    </div>
</template>

<script>
    import { Toast } from 'vant'

    export default {
        name: 'my',
        data() {
            return {
                userInfo: {
                    phone: ''
                },
                feeSummary: {
                    totalAmount: '0.00',
                    paidAmount: '0.00',
                    balance: '0.00'
                },
                orderCount: 0,
                processingCount: 0,
                isBound: true,
                showBindModal: false,
                bindForm: {
                    phone: '',
                    code: ''
                },
                countdown: 0
            }
        },
        computed: {
            formattedPhone() {
                if (!this.userInfo.phone) return '未绑定'
                return this.userInfo.phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
            }
        },
        mounted() {
            this.fetchUserInfo()
            this.fetchFeeSummary()
            this.fetchOrderCount()
        },
        methods: {
            async fetchUserInfo() {
                try {
                    let url = "/api-enterprise/employee/info2"
                    this.$api.post(url, {}, response => {
                        if (response.data.result == "success") {
                            this.userInfo = response.data.data
                            if(this.userInfo.phone){
                                this.isBound = true
                            }else{
                                this.isBound = false
                            }
                        } else if (response.data.errorCode == "NB") {
                            this.isBound = false
                        }
                    })
                } catch (err) {
                    console.error('fetchUserInfo fail:', err)
                }
            },

            async fetchFeeSummary() {
                try {
                    let url = "/api-enterprise/caregiver/order/feeSummary"
                    this.$api.post(url, {}, response => {
                        if (response.data.result == "success") {
                            let data = response.data.data
                            this.feeSummary.orderAmount_total = (data.orderAmount_total || 0).toFixed(2)
                            this.feeSummary.receivedAmount_total = (data.receivedAmount_total || 0).toFixed(2)
                            this.feeSummary.balance = ((data.receivedAmount_total || 0) - (data.orderAmount_total || 0)).toFixed(2)
                        }
                    })
                } catch (err) {
                    console.error('fetchFeeSummary fail:', err)
                }
            },

            async fetchOrderCount() {
                try {
                    let url = "/api-enterprise/caregiver/order/list"
                    this.$api.post(url, {}, response => {
                        if (response.data.result == "success") {
                            let datas = response.data.data || []
                            datas = datas.map(item => {
                                if (item.status === -1) {
                                    item.status = 99
                                }
                                return item
                            })
                            // 未完成订单：待接单(0) + 进行中(2)
                            this.orderCount = datas.filter(o => o.status === 0 || o.status === 2).length
                            // 进行中订单：状态为2
                            this.processingCount = datas.filter(o => o.status === 2).length
                        }
                    })
                } catch (err) {
                    console.error('fetchOrderCount fail:', err)
                }
            },

            sendCode() {
                if (!this.bindForm.phone) {
                    Toast('请输入手机号')
                    return
                }

                let url = '/api-enterprise/v1.0.1/sms/send'
                this.$api.post(url, { phone: this.bindForm.phone }, response => {
                    if (response.data.result === 'success') {
                        this.countdown = 60
                        let timer = setInterval(() => {
                            this.countdown--
                            if (this.countdown <= 0) {
                                clearInterval(timer)
                            }
                        }, 1000)
                        Toast('验证码已发送')
                    } else {
                        Toast(response.data.message || '发送失败')
                    }
                }, error => {
                    Toast('发送失败，请重试')
                })
            },

            async handleBind() {
                if (!this.bindForm.phone) {
                    Toast('请输入手机号')
                    return
                }
                if (!this.bindForm.code) {
                    Toast('请输入验证码')
                    return
                }

                try {
                    let url = "/api-enterprise/wx/bind2"
                    this.$api.post(url, {
                        code: this.bindForm.code,
                        phone: this.bindForm.phone
                    }, response => {
                        if (response.data.result == "success") {
                            Toast('绑定成功')
                            this.showBindModal = false
                           this.fetchUserInfo()
                        } else {
                            Toast(response.data.message || '绑定失败')
                        }
                    })
                } catch (err) {
                    console.error('handleBind fail:', err)
                }
            },

            goBack() {
                this.$router.back()
            },

            goToService() {
                Toast('客服功能开发中')
            },

            goToOrder(tab) {
                let tabIndex = 0
                if (tab === 'pending') {
                    tabIndex = 1
                } else if (tab === 'processing') {
                    tabIndex = 2
                } else if (tab === 'completed') {
                    tabIndex = 3
                }
                this.$router.push({
                    path: '/order',
                    query: { tab: tabIndex }
                })
            },

            goToContacts() {
                let enterpriseId=localStorage.getItem('caregiver_selected_enterprise_id')
                 this.$router.push({
                    path: '/patientList',
                    query: {enterpriseId:enterpriseId}
                })
            },

            goToPrivacy() {
                this.$router.push({path: '/privacy'})
            },
            handleTabClick() {
                // 路由跳转
                this.$router.replace({path: '/caregiverIndex'})
            }
        }
    }
</script>

<style scoped>
.page-container {
    min-height: 100vh;
    background: #f5f5f5;
    padding-bottom: env(safe-area-inset-bottom);
}

.header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 44px 16px 16px;
    background: linear-gradient(135deg, #1e88e5 0%, #42a5f5 100%);
    color: #fff;
}

.header .back-btn {
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.header .header-title {
    font-size: 18px;
    font-weight: bold;
}

.header .customer-service {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.9);
}

.user-section {
    background: linear-gradient(135deg, #1e88e5 0%, #42a5f5 100%);
    padding: 20px 16px 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.user-section .user-info {
    display: flex;
    align-items: center;
}

.user-section .user-info .avatar {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.user-section .user-info .avatar img {
    width: 60px;
    height: 60px;
}

.user-section .user-info .avatar .avatar-badge {
    position: absolute;
    bottom: -2px;
    right: -2px;
    background: #ff9800;
    color: #fff;
    font-size: 10px;
    padding: 2px 6px;
    border-radius: 10px;
}

.user-section .user-info .user-detail {
    margin-left: 16px;
    display: flex;
    flex-direction: column;
}

.user-section .user-info .user-detail .user-name {
    font-size: 18px;
    font-weight: bold;
    color: #fff;
    margin-bottom: 4px;
}

.user-section .user-info .user-detail .user-phone {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.8);
}

.user-section .bind-btn {
    background: rgba(255, 255, 255, 0.2);
    padding: 8px 16px;
    border-radius: 20px;
    color: #fff;
    font-size: 14px;
}

.fee-section {
    background: #fff;
    margin: -20px 16px 16px;
    border-radius: 16px;
    padding: 20px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    position: relative;
}

.fee-section .fee-item {
    margin-bottom: 12px;
}

.fee-section .fee-item .fee-label {
    font-size: 12px;
    color: #999;
    display: block;
    margin-bottom: 4px;
}

.fee-section .fee-item .fee-value {
    font-size: 24px;
    font-weight: bold;
    color: #333;
}

.fee-section .fee-item .fee-value.negative {
    color: #f44336;
}

.fee-section .fee-item.balance {
    text-align: center;
    padding-bottom: 16px;
    border-bottom: 1px dashed #eee;
    margin-bottom: 16px;
}

.fee-section .fee-row {
    display: flex;
    justify-content: space-between;
}

.fee-section .fee-row .fee-item {
    flex: 1;
    text-align: center;
}

.fee-section .order-badge {
    position: absolute;
    top: -10px;
    right: -10px;
    background: #f44336;
    color: #fff;
    font-size: 12px;
    padding: 4px 12px;
    border-radius: 12px;
}

.order-section {
    background: #fff;
    margin: 0 16px 16px;
    border-radius: 16px;
    padding: 16px;
}

.order-section .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
}

.order-section .section-header .section-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
}

.order-section .section-header .section-more {
    font-size: 14px;
    color: #1e88e5;
}

.order-section .order-tabs {
    display: flex;
    justify-content: space-around;
}

.order-section .order-tabs .order-tab {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
}

.order-section .order-tabs .order-tab .tab-icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
}

.order-section .order-tabs .order-tab .tab-icon img {
    width: 32px;
    height: 32px;
}

.order-section .order-tabs .order-tab .tab-icon.icon-pending {
    background: #fff3e0;
}

.order-section .order-tabs .order-tab .tab-icon.icon-processing {
    background: #e3f2fd;
}

.order-section .order-tabs .order-tab .tab-icon.icon-completed {
    background: #e8f5e9;
}

.order-section .order-tabs .order-tab .tab-text {
    font-size: 12px;
    color: #666;
}

.order-section .view-all-order {
    text-align: center;
    padding: 16px 0 8px;
    font-size: 14px;
    color: #999;
    border-top: 1px solid #f0f0f0;
    margin-top: 12px;
}

.menu-section {
    background: #fff;
    margin: 0 16px;
    border-radius: 16px;
    overflow: hidden;
}

.menu-section .menu-item {
    display: flex;
    align-items: center;
    padding: 16px;
    border-bottom: 1px solid #f0f0f0;
}

.menu-section .menu-item:last-child {
    border-bottom: none;
}

.menu-section .menu-item .menu-icon {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.menu-section .menu-item .menu-icon img {
    width: 32px;
    height: 32px;
}

.menu-section .menu-item .menu-text {
    flex: 1;
    margin-left: 12px;
    font-size: 16px;
    color: #333;
}

.menu-section .menu-item .menu-arrow {
    color: #ccc;
    font-size: 14px;
}

.bind-modal {
    background: #fff;
    border-radius: 16px 16px 0 0;
    padding-bottom: env(safe-area-inset-bottom);
}

.bind-modal .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    border-bottom: 1px solid #f0f0f0;
}

.bind-modal .modal-header .modal-title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
}

.bind-modal .modal-header .modal-close {
    font-size: 24px;
    color: #999;
    line-height: 1;
}

.bind-modal .modal-body {
    padding: 16px;
}

.bind-modal .modal-body .form-group {
    margin-bottom: 16px;
}

.bind-modal .modal-body .form-group .form-label {
    display: block;
    font-size: 14px;
    color: #666;
    margin-bottom: 8px;
}

.bind-modal .modal-body .form-group .form-input {
    width: 100%;
    height: 44px;
    border: 1px solid #eee;
    border-radius: 8px;
    padding: 0 12px;
    font-size: 16px;
    box-sizing: border-box;
}

.bind-modal .modal-body .form-group .form-input.code-input {
    width: calc(100% - 100px);
}

.bind-modal .modal-body .form-group .code-input-group {
    display: flex;
    gap: 8px;
}

.bind-modal .modal-body .form-group .code-btn {
    width: 92px;
    height: 44px;
    border: none;
    border-radius: 8px;
    background: #1e88e5;
    color: #fff;
    font-size: 14px;
}

.bind-modal .modal-body .form-group .code-btn:disabled {
    background: #ccc;
}

.bind-modal .modal-footer {
    padding: 16px;
}

.bind-modal .modal-footer .submit-btn {
    width: 100%;
    height: 44px;
    border-radius: 8px;
    font-size: 16px;
}
   .tab-bar-bottom {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        height: 56px;
        background: #ffffff;
        display: flex;
        justify-content: space-around;
        align-items: center;
        box-shadow: 0 -4px 15px rgba(0, 0, 0, 0.06);
        z-index: 999;
        padding-bottom: env(safe-area-inset-bottom);
    }
    .tab-bar-bottom-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        flex: 1;
        height: 100%;
        color: #999999;
        font-size: 12px;
        transition: all 0.2s ease;
        padding-top: 4px;
    }
    .tab-bar-bottom-item.active1 {
        color: #32C5A7;
    }
    .tab-icon {
        width: 24px;
        height: 24px;
        margin-bottom: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .tab-icon svg {
        width: 100%;
        height: 100%;
    }
    .tab-text {
        font-size: 11px;
        font-weight: 500;
    }
</style>